import { UserRole } from 'app-types';
import { FormattedMessage } from 'localization';

import { EnumDeskRoutes, EnumSettingRoutes } from '../../../constants';

const adminRoles = [UserRole.owner, UserRole.administrator, UserRole.manager];

const deskSection = [
  {
    value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.voiceCall}`,
    roles: adminRoles,
    label: (
      <div className="capitalize">
        <FormattedMessage id="desk-app.voice-call" />
      </div>
    ),
    isNew: true,
  },
  {
    value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.importData}`,
    roles: adminRoles,
    label: (
      <div className="capitalize">
        <FormattedMessage id="desk-app.import-data" />
      </div>
    ),
  },
  {
    value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.myProfile}`,
    label: (
      <div className="capitalize">
        <FormattedMessage id="desk-app.my-profile" />
      </div>
    ),
  },
  {
    value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.configuration}`,
    roles: adminRoles,
    label: (
      <div className="capitalize">
        <FormattedMessage id="desk-app.configuration" />
      </div>
    ),
  },
  {
    value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.courierSetting}`,
    roles: adminRoles,
    label: (
      <div className="capitalize">
        <FormattedMessage id="desk-app.couriers-settings" />
      </div>
    ),
  },
  {
    value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.agents}`,
    roles: adminRoles,
    label: (
      <div className="capitalize">
        <FormattedMessage id="desk-app.agents" />
      </div>
    ),
    title: ['Agents'],
  },
  {
    value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.teams}`,
    roles: adminRoles,
    label: (
      <div className="capitalize">
        <FormattedMessage id="desk-app.teams" />
      </div>
    ),
  },
  {
    value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.routingRules}`,
    roles: adminRoles,
    label: (
      <div className="capitalize">
        <FormattedMessage id="desk-app.routing-rules" />
      </div>
    ),
  },
  {
    value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.tags}`,
    roles: adminRoles,
    label: (
      <div className="capitalize">
        <FormattedMessage id="desk-app.tags" />
      </div>
    ),
  },
  {
    value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.templateLibrary}`,
    roles: adminRoles,
    label: (
      <div className="capitalize">
        <FormattedMessage id="desk-app.template-library" />
      </div>
    ),
  },
  {
    value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.rating}`,
    roles: adminRoles,
    label: (
      <div className="capitalize">
        <FormattedMessage id="desk-app.ratingPage" />
      </div>
    ),
    isNew: true,
  },
  {
    value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.personalFolders}`,
    label: (
      <div className="capitalize">
        <FormattedMessage id="desk-app.personal-folders" />
      </div>
    ),
  },
  {
    value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.companyFolders}`,
    roles: adminRoles,
    label: (
      <div className="capitalize">
        <FormattedMessage id="desk-app.company-folders" />
      </div>
    ),
  },
  {
    value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.aiSettings}`,
    roles: adminRoles,
    label: (
      <div className="capitalize">
        <FormattedMessage id="desk-app.ai-settings" />
      </div>
    ),
    isNew: true,
  },
];

export { deskSection, adminRoles };
